/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

const chapter = Vue.resource('chapters{/id}');

export default chapter;



// WEBPACK FOOTER //
// ./src/resources/chapter.js